module.exports = __webpack_public_path__ + "static/media/social-twitch.05e187c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-twitch.svg
// module id = 80
// module chunks = 0